module.exports = __webpack_public_path__ + "img/lnk-sales-footer.bad43d69.svg";